// src/services/axios.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000,  // Timeout de 10 secondes
});

axiosInstance.defaults.headers['Content-Type'] = 'application/json';
axiosInstance.defaults.withCredentials = true;

export default axiosInstance;
